module.exports = __webpack_public_path__ + "img/Wellcare.03d5d1c5.svg";